import { frontendURL } from 'dashboard/helper/URLHelper';
import store from 'dashboard/store';

const conversations = accountId => {
  const isPhoenix = store.getters['accounts/isPhoenix'];

  return {
  parentNav: 'conversations',
  routes: [
    'home',
    'inbox_dashboard',
    'inbox_conversation',
    'conversation_through_inbox',
    'notifications_dashboard',
    'label_conversations',
    'conversations_through_label',
    'team_conversations',
    'conversations_through_team',
    'conversation_mentions',
    'conversation_through_mentions',
    'conversation_participating',
    'conversation_through_participating',
    'folder_conversations',
    'conversations_through_folders',
    'conversation_unattended',
    'conversation_through_unattended',
  ],
  menuItems: [
    {
      icon: 'chat',
      label: 'SIDEBAR.ALL_CONVERSATIONS',
      key: 'conversations',
      toState: frontendURL(`accounts/${accountId}/dashboard`),
      toolTip: 'Conversation from all subscribed inboxes',
      toStateName: 'home',
    },
    {
      icon: 'mention',
      label: 'SIDEBAR.MENTIONED_CONVERSATIONS',
      key: 'conversation_mentions',
      toState: frontendURL(`accounts/${accountId}/mentions/conversations`),
      toStateName: 'conversation_mentions',
    },
    ...(!isPhoenix
      ? [
          {
            icon: 'mail-unread',
            label: 'SIDEBAR.UNATTENDED_CONVERSATIONS',
            key: 'conversation_unattended',
            toState: frontendURL(
              `accounts/${accountId}/unattended/conversations`
            ),
            toStateName: 'conversation_unattended',
          },
        ]
      : []),
  ],
};
};

export default conversations;
